import { compose } from 'redux';
import middlewares from 'core/middlewares';

const composeEnhancers = NODE_ENV == 'production' ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const stateEnhancer = composeEnhancers(
  middlewares,
);

export default stateEnhancer;



// WEBPACK FOOTER //
// ./src/core/stateEnhancer.js